import SwiperCarousel from '../utils/swiper-carousel';
import './recommended-categories.css';

export default (element) => {
  const el = element.querySelector('[data-recommended-categories]');

  if (!el) return;

  const init = () => {
    // eslint-disable-next-line no-new
    new SwiperCarousel(el, {
      slidesPerView: 1.344,
      spaceBetween: 20,
      allowTouchMove: true,
      navigation: {
        nextEl: element.querySelector('.next'),
        prevEl: element.querySelector('.prev'),
      },
      breakpoints: {
        768: {
          slidesPerView: 3.2,
        },
        1199: {
          slidesPerView: 4.001,
        },
      },
      mousewheel: {
        forceToAxis: true,
      },
    });
  };

  init();
};
